import React from "react";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      {/* Removed "Days I Code" section */}
    </Row>
  );
}

export default Github;